module.exports = "/assets/data/50c4bed31a5d9ac1b4bbc55e593084ca-SP7.data.json";